<template>
  <div class="app-screen">
    <div class="top-panel global-offset">
      <div class="report">
        <div class="arrow"></div>
        <div class="info">
          <p>Behavior Anomalies</p>

          <div class="breadcrumbs-sc">
            <span>Home</span> <i class="glyphicon glyphicon-menu-right"></i>
            Behavior Anomalies
          </div>
        </div>
      </div>
    </div>

    <div class="line"></div>
    <div class="app-body global-offset">
      <div class="left-side">
        <div class="risk-score-timeline">
          <div class="last-thirty-days">
            Last 30 days
          </div>
          <div class="controls">
            <img src="//img.netwrix.com/elements/onlineDemo/ui_icons/bars-icon.v001.png" alt="">
            <img src="//img.netwrix.com/elements/onlineDemo/ui_icons/torus-icon-active.png" alt="">
          </div>
          <div class="pie-chart-cont">
            <div class="title">
              RISK SCORE BY TOP FIVE ALERTS
            </div>
            <div class="pie-chart">
              <img src="//img.netwrix.com/elements/onlineDemo/graphs/chart.png" alt="">
            </div>
            <div class="legend-col">
              <div class="segment segment-red">405&nbsp;&nbsp;Potentially Harmful File Created on File
                Server
              </div>
              <div class="segment segment-blue">270&nbsp;&nbsp;Potentially Harmful File Created on
                SharePoint
              </div>
              <div class="segment segment-purple">150&nbsp;&nbsp;Mass Data Removal from File Servers</div>
            </div>
            <div class="legend-col">
              <div class="segment segment-green">20&nbsp;&nbsp;Failed Access to the Accounting Folder
              </div>
              <div class="segment segment-yellow">10&nbsp;&nbsp;Failed Access to the Business Improvements
                Folder
              </div>
            </div>
          </div>
        </div>
        <div class="alerts-list">
          <div class="list-header">
            <div>Alert time</div>
            <div>Alert name</div>
            <div>Risk score</div>
            <div>Status</div>
          </div>
          <div class="list-row" v-for="(alert, index) in alerts" :key="index">
            <div>{{ alert.time }}</div>
            <div>{{ alert.name }}</div>
            <div>{{ alert.risk_score }}</div>
            <div>Active</div>
          </div>
        </div>
      </div>
      <div class="right-side">
        <div class="user">ENTEPRISE\T.Simpson</div>
        <div class="total-risk-score">Total risk score: <span>855</span></div>
        <div class="action" @click="(currentStep === 8) ? $root.$emit(EVENT_NEXT_STEP) : ''">Show user
          activity
        </div>

        <div class="filters-title">Filters</div>
        <div class="filter-link-1">Customize view</div>
        <div class="filter-link-2">All filters selected</div>
        <div class="filter-link-3">Show reviewed anomalies</div>

        <div class="actions-title">Actions</div>
        <div class="action-link-1" @click="(currentStep === 11) ? $root.$emit(EVENT_NEXT_STEP) : ''">Mark all as
          reviewed
        </div>
        <div class="action-link-2">Refresh</div>
      </div>
    </div>

    <div class="line"></div>

    <div class="bottom-block global-offset"></div>

    <div class="modal-backdrop" v-if="isModalDialogShown"></div>
    <div class="modal-dialog" v-if="isModalDialogShown">
      <div class="blue-text">
        Change Status
      </div>
      <p>
        Update 21 anomalies that are currently in view and set their status to:
      </p>
      <div class="radio-buttons-cont">
        <div>
          <input type="radio" name="status">Active
        </div>
        <div>
          <input type="radio" name="status" checked>Reviewed
        </div>
      </div>
      <p>
        Once anomaly is reviewed, it’s risk score is taken from a user’s total score.
      </p>
      <label>Comment:</label>
      <Autocomplete-textarea :list="['Possible data theft and sabotage by a departing employee. The incident is being reviewed by the legal team.']"
                             :classList="['modal-textarea-input']"
                             :hint="false"
                             v-model="comment"/>
      <p>
        Note: Hidden anomalies will not be affected by this change.
      </p>
      <div class="buttons-cont">
        <button class="blue" @click="isInputsFilled ? $root.$emit(EVENT_NEXT_STEP) : ''">
          OK
        </button>
        <button>Cancel</button>
        <div :class="{'fake-frame': true, 'frame-show':isInputsFilled}"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import AutocompleteTextarea from './../../../utils/AutocmpleteTextarea';
  import { mapState } from 'vuex';
  import spacers from '@/mixins/spacers';

  import { EVENT_NEXT_STEP } from '@/constants';

  export default {
    name: 'dashboard-screen-sc10-st2_5',
    mixins: [spacers],
    components: {
      AutocompleteTextarea,
    },
    data() {
      return {
        currentLeftSpacer: 'spacer-risk-assessment-overview',
        currentRightSpacer: 'spacer-risk-assessment-overview',
        EVENT_NEXT_STEP: EVENT_NEXT_STEP,
        bars: [67, 64, 61, 67, 58, 57, 55, 57, 47, 61, 42, 62, 52, 64, 69, 67, 70, 69, 61, 64, 61, 81, 95, 99, 81, 99, 99, 108, 100, 62],
        alerts: [
          {
            time: '10/28/2018  12:16:21 AM',
            name: 'Potentially Harmful File Created on SharePoint',
            risk_score: 45,
          },
          {
            time: '10/28/2018  12:16:21 AM',
            name: 'Potentially Harmful File Created on SharePoint',
            risk_score: 45,
          },
          {
            time: '10/28/2018  12:16:21 AM',
            name: 'Potentially Harmful File Created on SharePoint',
            risk_score: 45,
          },
          {
            time: '10/28/2018  12:16:21 AM',
            name: 'Potentially Harmful File Created on SharePoint',
            risk_score: 45,
          },
          {
            time: '10/28/2018  12:16:21 AM',
            name: 'Potentially Harmful File Created on SharePoint',
            risk_score: 45,
          },
          {
            time: '10/28/2018  12:16:21 AM',
            name: 'Potentially Harmful File Created on SharePoint',
            risk_score: 45,
          },
          {
            time: '10/28/2018  12:08:12 AM',
            name: 'Potentially Harmful File Created on File Server',
            risk_score: 45,
          },
          {
            time: '10/28/2018  12:08:12 AM',
            name: 'Potentially Harmful File Created on File Server',
            risk_score: 45,
          },
          {
            time: '10/28/2018  12:08:12 AM',
            name: 'Potentially Harmful File Created on File Server',
            risk_score: 45,
          },
          {
            time: '10/28/2018  12:08:12 AM',
            name: 'Potentially Harmful File Created on File Server',
            risk_score: 45,
          },
          {
            time: '10/28/2018  12:08:12 AM',
            name: 'Potentially Harmful File Created on File Server',
            risk_score: 45,
          },
          {
            time: '10/28/2018  12:08:12 AM',
            name: 'Potentially Harmful File Created on File Server',
            risk_score: 45,
          },
          {
            time: '10/28/2018  12:08:12 AM',
            name: 'Potentially Harmful File Created on File Server',
            risk_score: 45,
          },
          {
            time: '10/28/2018  12:08:12 AM',
            name: 'Potentially Harmful File Created on File Server',
            risk_score: 45,
          },
          {
            time: '10/28/2018  12:08:12 AM',
            name: 'Potentially Harmful File Created on File Server',
            risk_score: 45,
          },
          {
            time: '10/28/2018  12:02:56 AM',
            name: 'Mass Data Removal from File Servers',
            risk_score: 50,
          },
          {
            time: '10/28/2018  12:01:45 AM',
            name: 'Mass Data Removal from File Servers',
            risk_score: 50,
          },
          {
            time: '10/28/2018  12:00:34 AM',
            name: 'Mass Data Removal from File Servers',
            risk_score: 50,
          },
          {
            time: '10/28/2018  11:57:56 PM',
            name: 'Failed Access to the Accounting Folder',
            risk_score: 10,
          },
          {
            time: '10/28/2018  11:56:32 PM',
            name: 'Failed Access to the Accounting Folder',
            risk_score: 10,
          },
          {
            time: '10/28/2018  11:54:40 PM',
            name: 'Failed Access to the Business Improvements Folder',
            risk_score: 10,
          },
        ],
        steps: {
          modalDialogShown: 12,
        },
        comment: '',
      };
    },
    computed: {
      ...mapState('guide', ['currentStep']),
      isModalDialogShown() {
        return (this.currentStep === this.steps.modalDialogShown);
      },
      isInputsFilled() {
        return (this.comment.toLowerCase() == 'possible data theft and sabotage by a departing employee. the incident is being reviewed by the legal team.');
      },
    },
  };
</script>

<style lang="less" scoped>
  @borderColor: #d5d5d5;

  .line {
    border-bottom: 1px solid @borderColor;
  }

  .modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.7);
    z-index: 2;
  }

  .modal-dialog {
    position: absolute;
    left: 452px;
    top: 188px;
    width: 521px;
    box-shadow: 0 0 20px rgba(65, 64, 66, 0.3);
    border: 1px solid #1472bb;
    background-color: #ffffff;
    padding: 17px 25px;
    z-index: 3;
    margin: 30px auto !important;

    .blue-text {
      color: #0d71b9;
      font-size: 16px;
      font-weight: 400;
      line-height: 32px;
      margin-bottom: 16px;
    }

    p {
      font-size: 13px;
      font-weight: 400;
      line-height: 20px;
      color: #202020;
      margin-bottom: 10px;
    }

    .radio-buttons-cont {
      color: #202020;
      font-size: 13px;
      font-weight: 400;
      line-height: 30px;
      margin-bottom: 12px;
      pointer-events: none;

      input {
        position: relative;
        top: 2px;
        margin-right: 8px;
      }
    }

    label {
      color: #202020;
      font-size: 13px;
      font-weight: 600;
      line-height: 20px;
      margin-top: 13px;
    }

    .buttons-cont {
      text-align: right;

      .fake-frame {
        position: absolute;
        border: 2px solid #da262e;
        width: 101px;
        height: 37px;
        right: 111px;
        bottom: 12px;
        pointer-events: none;
        opacity: 0;
        transition: opacity 0.3s;

        &.frame-show {
          opacity: 1;
        }
      }

      button {
        color: #1472bb;
        font-size: 14px;
        font-weight: 600;
        line-height: 26px;
        border: 1px solid #1472bb;
        background: #fff;
        min-width: 88px;
        padding: 0 20px;

        &:nth-child(1) {
          margin-left: 136px;
        }

        &.blue {
          background-color: #1472bb;
          color: #fff;
          margin-right: 4px;
        }
      }
    }
  }

  .app-screen {
    .top-panel {
      margin-bottom: 5px;
      text-align: center;
      position: relative;

      .report {
        text-align: left;

        .arrow,
        .info {
          display: inline-block;
          vertical-align: top;
        }

        .arrow {
          width: 26px;
          height: 26px;
          background: url(//img.netwrix.com/elements/onlineDemo/ui_icons/arrow_back_ico.svg) 0 50% no-repeat;
          margin-right: 12px;
          cursor: pointer;
        }

        .info {
          p {
            font-size: 22px;
            margin-bottom: 0;
            color: #202020;
          }

          .breadcrumbs-sc {
            color: #58595b;
            font-size: 13px;
            font-weight: 400;
            line-height: 26px;

            .glyphicon {
              font-size: 12px;
            }

            span {
              color: #0d71b9;
            }
          }
        }
      }
    }

    .app-body {
      font-size: 0;
      white-space: nowrap;

      .left-side {
        width: 1136px;
        display: inline-block;
      }

      .right-side {
        height: 1091px;
        display: inline-block;
        border-left: 1px solid #dedfde;
        vertical-align: top;
        padding-top: 15px;
        width: 310px;

        @mainOffset: 22px;

        .user {
          color: #202020;
          font-size: 13px;
          font-weight: 400;
          line-height: 20px;
          padding-left: @mainOffset;
          margin-bottom: 22px;

          &:before {
            display: inline-block;
            content: '';
            border: 1px solid #b1d1eb;
            width: 45px;
            height: 45px;
            border-radius: 50%;
            vertical-align: middle;
            margin-right: 10px;
            background: url('//img.netwrix.com/elements/onlineDemo/ui_icons/user-icon.png') center no-repeat;
          }
        }

        .total-risk-score {
          color: #848284;
          font-size: 13px;
          font-weight: 400;
          line-height: 20px;
          padding-left: @mainOffset;
          margin-bottom: 22px;

          span {
            color: #202020;
            font-size: 15px;
            font-weight: 600;
            line-height: 20px;
          }
        }

        .before-mixin {
          display: inline-block;
          content: '';
          vertical-align: middle;
          margin-right: 10px;
        }

        .action {
          color: #0d71b9;
          font-size: 13px;
          font-weight: 600;
          line-height: 20px;
          padding-left: @mainOffset;
          margin-bottom: 49px;
          cursor: pointer;

          &:before {
            .before-mixin();
            width: 16px;
            height: 16px;
            background: url('//img.netwrix.com/elements/onlineDemo/ui_icons/na-icon-small.png') center no-repeat;
          }
        }

        .filters-title, .actions-title {
          color: #848284;
          font-size: 15px;
          font-weight: 400;
          line-height: 20px;
          border-bottom: 1px solid #dedfde;
          padding: 5px 0 10px @mainOffset;
          margin-bottom: 11px;
        }

        .filter-link-1, .filter-link-3, .action-link-1, .action-link-2 {
          color: #0d71b9;
          font-size: 13px;
          font-weight: 600;
          line-height: 20px;
          padding-left: @mainOffset;
          margin-bottom: 16px;
          cursor: pointer;
        }

        .filter-link-1:before {
          .before-mixin();
          width: 14px;
          height: 13px;
          background: url('//img.netwrix.com/elements/onlineDemo/ui_icons/customize-filter-icon.png') center no-repeat;
        }

        .filter-link-2 {
          color: #848284;
          font-size: 13px;
          font-weight: 600;
          line-height: 20px;
          padding-left: @mainOffset;
          margin-bottom: 16px;
          cursor: pointer;
        }

        .filter-link-3 {
          margin-bottom: 160px;
        }

        .filter-link-3:before {
          .before-mixin();
          width: 14px;
          height: 13px;
          background: url('//img.netwrix.com/elements/onlineDemo/ui_icons/show-reviewed-anomalies-icon.png') center no-repeat;
        }

        .action-link-1:before {
          .before-mixin();
          width: 18px;
          height: 15px;
          background: url('//img.netwrix.com/elements/onlineDemo/ui_icons/hide-icon.png') center no-repeat;
        }

        .action-link-2:before {
          .before-mixin();
          width: 18px;
          height: 16px;
          background: url('//img.netwrix.com/elements/onlineDemo/ui_icons/refresh-icon.png') center no-repeat;
        }
      }

      .risk-score-timeline {
        margin-top: 32px;
        position: relative;

        .last-thirty-days {
          color: #0d70b8;
          font-size: 13px;
          font-weight: 400;
          line-height: 20px;
          position: absolute;
          top: -6px;
          right: 18px;
        }

        .controls {
          width: 89px;
          text-align: center;
          display: inline-block;
          white-space: normal;

          img {
            margin-bottom: 8px;
          }
        }

        .pie-chart-cont {
          display: inline-block;
          vertical-align: top;

          .title {
            color: #7b838a;
            font-size: 13px;
            font-weight: 600;
            line-height: 0.7;
            text-transform: uppercase;
          }

          .pie-chart {
            display: inline-block;
            margin-top: 22px;
            margin-left: 33px;
            margin-right: 44px;
            position: relative;

            &:before {
              content: '855';
              display: block;
              position: absolute;
              top: 58px;
              left: 54px;
              color: #202020;
              font-size: 16px;
              font-weight: 600;
              line-height: 20px;
              z-index: 2;
            }
          }

          .legend-col {
            display: inline-block;
            vertical-align: top;
            color: #202020;
            font-size: 12px;
            font-weight: 400;
            margin-top: 49px;
            line-height: 26px;
            margin-right: 71px;

            .segment {
              &:before {
                display: inline-block;
                content: '';
                width: 9px;
                height: 9px;
                margin-right: 6px;
              }

              &-red:before {
                background: #ff4a5b;
              }

              &-blue:before {
                background: #479ee8;
              }

              &-purple:before {
                background: #ac60d9;
              }

              &-green:before {
                background: #82c665;
              }

              &-yellow:before {
                background: #ffdf2e;
              }
            }
          }
        }
      }

      .alerts-list {
        width: 1136px;
        margin-top: 29px;

        .list-header {
          font-size: 0;

          & > div {
            display: inline-block;
            background-color: #d7effe;
            height: 25px;
            color: #202020;
            font-size: 12px;
            font-weight: 600;
            line-height: 2.3;
            padding: 0 7px;
            margin-left: 2px;

            &:nth-child(1) {
              width: 255px;
            }

            &:nth-child(2) {
              width: 414px;
            }

            &:nth-child(3) {
              width: 216px;
            }

            &:nth-child(4) {
              width: 241px;
            }
          }
        }

        .list-row {
          font-size: 0;
          height: 40px;

          & > div {
            display: inline-block;
            color: #202020;
            font-size: 13px;
            font-weight: 400;
            padding: 9px 7px;
            margin-left: 2px;

            &:nth-child(1) {
              width: 255px;
              position: relative;

              &:before {
                content: '';
                display: inline-block;
                vertical-align: middle;
                width: 6px;
                height: 11px;
                margin-right: 8px;
                background: url('//img.netwrix.com/elements/onlineDemo/ui_icons/triangle.png') center no-repeat;
              }
            }

            &:nth-child(2) {
              width: 414px;
            }

            &:nth-child(3) {
              width: 216px;
            }

            &:nth-child(4) {
              width: 241px;
              color: #0d70b8;

              &:before {
                content: '';
                display: inline-block;
                vertical-align: middle;
                width: 12px;
                height: 13px;
                margin-right: 8px;
                background: url('//img.netwrix.com/elements/onlineDemo/ui_icons/edit-status.png') center no-repeat;
              }
            }
          }
        }
      }
    }

    .bottom-block {
      padding-top: 9px;
      height: 39px;

      .btn {
        border-radius: 0;
        min-width: 100px;
        padding: 4px 0;

        margin-right: 2px;

        &.blue {
          background-color: #1472bb;
          color: #ffffff;
        }

        &.white {
          color: #1472bb;
          border: 1px solid #1472bb;
        }
      }
    }
  }
</style>